import { BPMAnalyticsAPI } from "api"
import { FilterContextType, FilterParams } from "components/context/filter"
import DataGrid, { Column, ColumnChooser, Export, FilterRow, Format, GroupPanel, Grouping, HeaderFilter, Paging, SearchPanel, StateStoring } from "devextreme-react/data-grid"
import { exportDataGrid } from "devextreme/excel_exporter"
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import * as React from "react"
import { useDebounce } from "utils/useDebounce";

export const ChurnData: React.FC = () => {
    const [data, setData] = React.useState<any[]>([])
    const datagrid = React.useRef<DataGrid | undefined | null>(null)
    const filterContext = React.useContext(FilterContextType)
    const debouncedValue = useDebounce<typeof filterContext>(filterContext, 500)

    React.useEffect(() => {
        setData([])
        datagrid.current?.instance.beginCustomLoading('Loading...')
        BPMAnalyticsAPI.getv2<any>(`churn-rate`, { ...debouncedValue } as FilterParams & { query: string }).then((d) => {
            setData(d)
            datagrid.current?.instance.endCustomLoading()
        })
    }, [debouncedValue])

    const onExporting = (e) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Financial-Data.xlsx');
                });
        });
    }

    return <div>
        <h4 style={{ marginBottom: 10 }}>Financial Data</h4>
        <div style={{ marginBottom: 10 }}>Note: Library filter is not applied to this chart!</div>
        <DataGrid ref={(ref) => datagrid.current = ref} dataSource={data} allowColumnReordering onExporting={onExporting} columnAutoWidth
            allowColumnResizing columnResizingMode='widget' rowAlternationEnabled>
            <Column dataField={'cur_date'} caption="Month" dataType={'string'} allowFiltering={true} allowSearch={true}></Column>
            <Column dataField={'subscription_name'} dataType={'string'} allowFiltering={true} allowSearch={true}></Column>
            <Column dataField={'platform'} dataType={'string'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'library'} dataType={'string'} allowFiltering={true} allowSearch={true}></Column>

            <Column dataField={'prior_month_users'} caption="Prior Month Users" dataType={'number'} allowFiltering={true} allowSearch={true}></Column>
            <Column dataField={'current_month_users'} caption="Current Month Users" dataType={'number'} allowFiltering={true} allowSearch={true}></Column>
            <Column dataField={'churned_users'} caption="Churned Users" dataType={'number'} allowFiltering={true} allowSearch={true}></Column>
            <Column dataField={'users_cancelled'} caption="Cancel Intent Users" dataType={'number'} allowFiltering={true} allowSearch={true}></Column>
            <Column dataField={'current_month_revenue'} caption="Revenue" dataType={'number'} allowFiltering={true} allowSearch={true}></Column>
            <Column dataField={'new_revenue'} caption="Period New Revenue" dataType={'number'} allowFiltering={true} allowSearch={true}></Column>
            <Column dataField={'retained_upgrade_revenue'} caption="Period Upgrade Revenue" dataType={'number'} allowFiltering={true} allowSearch={true}></Column>

            <Column dataField={'revenue_churn_rate'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'churn_rate'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'renewal_rate'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>

            <Column dataField={'retained_users'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'new_users'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'returned_users'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'consecutive_users'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>

            <Column dataField={'retained_upgrade'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'retained_downgrade'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'retained_static'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'retained_revenue_total'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'retained_revenue_static'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'retained_revenue_increased'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'retained_revenue_decreased'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>

            <Column dataField={'involuntary_cancellation_revenue'} dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
            <Column dataField={'involuntary_cancellations'} caption="Involuntary Churn" dataType={'number'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>


            <SearchPanel visible />
            <FilterRow visible />
            <HeaderFilter visible />
            <Export enabled />
            <ColumnChooser enabled search={{ enabled: true }} allowSearch mode='select' height={600} />
            <Paging defaultPageSize={20} />
            <StateStoring enabled storageKey='analytics_v5_fin_churn' />
            <GroupPanel visible />
            <Grouping />
        </DataGrid>
    </div>
}


// WEBPACK FOOTER //
// ./src/pages/Financial/charts/Churn.tsx